// DS1.7.3
import React from 'react';
import classnames from 'classnames';
import MultiImage from '../../Icons/16x16/MultiImage';
import { IconSize } from '../../Icons/IconWrap';

import s from './MediaIndicator.scss';

interface Props {
  type?: 'gif' | 'video' | 'hd';
  /** if known, duration in seconds */
  duration?: number;
  isMultiImage?: boolean;
  className?: string;
}

function formatDuration(duration = 0) {
  if (!duration) {
    return null;
  }

  const seconds = duration % 60;
  const minutes = (duration - seconds) / 60;

  return `${minutes}:${seconds < 10 ? `0${seconds}` : seconds}`;
}

const MediaIndicator: React.FC<Props> = ({
  type,
  duration,
  isMultiImage,
  className,
}) => {
  if (!isMultiImage && !type) {
    return null;
  }

  return (
    <div className={classnames(s['root'], className)}>
      {isMultiImage ? (
        <MultiImage
          disableDefaultColors
          aria-label="stack of images"
          size={IconSize.SMALLER}
        />
      ) : (
        <>
          {type === 'gif' && 'GIF'}
          {type === 'video' && formatDuration(duration)}
          {type === 'hd' && 'HD'}
        </>
      )}
    </div>
  );
};
MediaIndicator.displayName = 'MediaIndicator';

export default MediaIndicator;
